// The check page of the past-readings import (feedback #67), kept pure so
// the hold-back and the recent-test offer are tested as behaviour.
import { readingNeedsConfirm } from '../../shared/reading-confirm.js';

// A typo (86.8 for 8.68) or a wrong unit imports silently otherwise:
// imports skip the outlier check. Far outside the keeper's own range, by
// the same rule as the "Are you sure?" on a typed test, with the tank's
// phase left out because a sheet's history spans phases. A phosphate
// above zero but under 0.001 ppm is smaller than a test kit shows, the
// mark of a wrong unit (review, 2026-10-08: ppm read as ppb phosphorus).
export function farOutRows(rows, tank, cards) {
  const asked = { ...tank, phase: null };
  return (rows || []).filter(
    (r) =>
      (r.param === 'phosphate' && r.value > 0 && r.value < 0.001) ||
      readingNeedsConfirm(asked, r.param, r.value, cards?.[r.param]?.acceptable)
  );
}

export function rowsToImport(rows, farOut, include) {
  if (include || !farOut?.length) return rows || [];
  const out = new Set(farOut);
  return (rows || []).filter((r) => !out.has(r));
}

// The newest recent test of each kind, the one to offer as a test. A kind
// already saved this visit is not offered again, even if the re-check
// that followed failed: POST readings has no duplicate guard.
export function newestRecent(refused, savedParams = new Set()) {
  const by = {};
  for (const r of refused || []) {
    if (r.code !== 'recent' || savedParams.has(r.param)) continue;
    if (!by[r.param] || r.ts > by[r.param].ts) by[r.param] = r;
  }
  return Object.values(by);
}

// "today", "yesterday", "19 days ago", by the keeper's calendar day: a
// recent test can be weeks old, and saving it can send an alert.
export function daysAgoText(ts, now = Date.now()) {
  const day = (x) => {
    const d = new Date(x);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  };
  const days = Math.round((day(now) - day(ts)) / 86400000);
  if (!Number.isFinite(days) || days <= 0) return 'today';
  return days === 1 ? 'yesterday' : `${days} days ago`;
}
